import { Injectable, ComponentFactoryResolver, ReflectiveInjector, Provider, ComponentRef, InjectFlags, NgModuleFactory, Injector, Optional, forwardRef, NgModuleRef } from '@angular/core';
import { BsModalRef, BsModalService } from '@farris/ui-modal';
import { FarrisFormService } from './farris-form.service';
import { FrameContext, FrameComponent, BindingList } from '@farris/devkit';
import { of, Observable, Subject } from 'rxjs';
import { LanguageService } from './languag.service';
import { switchMap } from 'rxjs/operators';
import { INSIDE_DIALOG_TOKEN, MODAL_REF } from './types';

declare const System: any;
/**
 * å¼¹çªæå¡
 * @scope FormModule
 */
@Injectable()
class DialogService {
  private _providers: Provider[] = [];
  /**
   * å¤é¨å¼ç¨
   */
  private refs: any = {};
  private languageService: LanguageService;
  private modalRef: any;
  private modals: any = {};

  constructor(
    private modalService: BsModalService,
    private farrisFormService: FarrisFormService,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private frameContext?: FrameContext,
    @Optional() private injector?: Injector
  ) {
    this.setLanguageService();
  }

  /**
   * è®¾ç½®è¯­è¨æå¡
   */
  private setLanguageService() {
    // FrameContextä¸ä¸å®å­å¨ï¼ä¸è½ç´æ¥ç¨
    const frameContext = this.getFrameContext();
    if (frameContext) {
      const injector = this.frameContext.injector;
      this.languageService = injector.get<LanguageService>(LanguageService, null, InjectFlags.Optional);
    }

    if (!this.languageService) {
      this.languageService = LanguageService.getInstance();
    }
  }

  /**
   * å¼å®¹æ§å¼¹çªï¼è·åframeContext
   */
  private getFrameContext() {
    if (this.frameContext) {
      return this.frameContext;
    }
    if (this['context'] && this['context']['frameContext']) {
      return this['context']['frameContext'];
    }
    return null;
  }
  /**
   * å¼å®¹æ§å¼¹çªï¼è·åComponentFactoryResolver
   */
  private getComponentFactoryResolver() {
    const frameContext = this.getFrameContext();
    let componentFactoryResolver: any;
    if (frameContext) {
      componentFactoryResolver = frameContext.injector.get(ComponentFactoryResolver);
    }
    return componentFactoryResolver;
  }

  /**
   * è·åconfigè½¬æ¢æå¯¹è±¡ç±»åçéç½®
   * @param config éç½®é¡¹
   * @throws å¡«åå¯¹è±¡æ ¼å¼æjsonå­ç¬¦ä¸²
   */
  private getObjectTypeConfig(config: any) {
    let objectTypeConfig: any
    if (typeof config === 'string') {
      if (config.length) {
        try {
          objectTypeConfig = JSON.parse(config);
        } catch {
          throw new Error(config + 'ä¸æ¯åæ³çjsonå­ç¬¦ä¸²');
        }
      } else {
        objectTypeConfig = {};
      }
    } else if (typeof config === 'object') {
      objectTypeConfig = Object.assign({}, config);
    } else {
      throw new Error('å¡«åå¯¹è±¡æ ¼å¼æjsonå­ç¬¦ä¸²');
    }
    return objectTypeConfig;
  }

  /**
   * åå»ºæ¨¡ææ¡åç»ä»¶å®ä¾ï¼å¹¶è¿åæ¨¡ææ¡å®ä¾ï¼åäºå¼å®¹èè¡¨åå¤ç
   * @param config å¼¹çªéç½®
   * @param component å¼¹çªåç»ä»¶
   * @param uiStateObject ç»å®å¼¹çªåç»ä»¶uiState
   */
  private createModalComponentRef(config: any, component: any, uiStateObject: any) {
    let componentRef: any;
    let modalRef: any;
    const frameContext = this.getFrameContext();
    const componentFactoryResolver = this.getComponentFactoryResolver();
    if (frameContext && componentFactoryResolver) {
      const contentCmptFactory = componentFactoryResolver.resolveComponentFactory(component);
      const injector = this.createInjector(this.refs, this.frameContext.injector);
      const modalContentInjector = ReflectiveInjector.resolveAndCreate([...this._providers], injector);
      componentRef = contentCmptFactory.create(modalContentInjector);
      if (componentRef && componentRef.instance && componentRef.instance.viewModel && componentRef.instance.viewModel.uiState) {
        if (typeof uiStateObject === 'object' && Object.keys(uiStateObject).length) {
          Object.keys(uiStateObject).forEach((item) => {
            componentRef.instance.viewModel.uiState.setPropertyValue(item, uiStateObject[item]);
          });
        }
        // éå isDialogåæ°
        componentRef.instance.viewModel.uiState.setPropertyValue('DEVKIT_DIALOG', true);
      }
      modalRef = this.modalService.show(componentRef, config);
    } else {
      modalRef = this.modalService.show(component, config);
    }
    return modalRef;
  }
  /**
   *æå¼å¼¹çª
   * @param config æ¨¡ææ¡æ¬èº«éç½®
   * @param modalId æ¨¡ææ¡åç»ä»¶çid
   * @param uiStateConfig æ¨¡ææ¡åç»ä»¶uiStateä¸çå­æ®µåå¼
   * @param callback åè°
   */
  public openModal(config: any = {}, modalId: string, uiStateConfig: any = {}, callback?: (modalRef: any) => any) {
    const configObj = this.getObjectTypeConfig(config);
    const uiStateObject = this.getObjectTypeConfig(uiStateConfig);
    const innerCompopnent = this.farrisFormService.getControls(modalId);
    let modalRef: any;
    let modalConfig: any = {
      title: this.languageService.defaultDialogTitle,
      width: 760,
      height: 450,
      showButtons: false
    };
    modalConfig = Object.assign(modalConfig, configObj);
    const onClosingHandler = modalConfig.beforeClose;
    // tslint:disable: no-string-literal
    const cancelChanges = modalConfig['cancelChanges'] || false;
    modalConfig.beforeClose = (ref) => {
      // if (ref && ref.modalRef && ref.modalRef.content) {
      //   ref.modalRef.content.isDialogRootComponent = false;
      // }
      if (!!onClosingHandler && typeof onClosingHandler === 'function') {
        return onClosingHandler(ref).pipe(
          switchMap((result) => {
            if (result) {
              if (cancelChanges) {
                return this.cancelChanges(ref);
              }
            }
            return of(result);
          })
        );
      }
      if (cancelChanges) {
        return this.cancelChanges(ref);
      } else {
        return of(true);
      }
    };
    const remote = modalConfig.remote || false;
    if (remote) {
      this.createRemoteForm(modalConfig, uiStateObject).subscribe(
        (modalRef: any) => {
          this.modalRef = modalRef;
          this.refs.modalRef = modalRef;
          if (modalRef && !!modalRef.content) {
            modalRef.content.isDialogRootComponent = true;
            modalRef.content.dialogRef = modalRef;
          }
          callback(modalRef);
        }
      );
    } else {
      if (!innerCompopnent) {
        console.error(`è·åæ§ä»¶å¤±è´¥ï¼modalId=${modalId}`);
        return;
      }
      if (typeof innerCompopnent === 'string') {
        modalConfig.dialogType = 'iframe';
        modalRef = this.modalService.show(innerCompopnent, modalConfig);
      } else if (typeof innerCompopnent === 'function') {
        modalRef = this.createModalComponentRef(modalConfig, innerCompopnent, uiStateObject);
      } else if (typeof innerCompopnent === 'object') {
        // å¦ææ¯å¯¹è±¡ ä¸ä½¿ç¨ç¬ç«jså è½½
        // {"useIsolateJs":true,"modalInstance":f()}
        if (innerCompopnent.useIsolateJs) {
          const injector = this.createInjector(this.refs);
          const parameter = {
            injector: injector,
            uiState: uiStateObject,
            modalService: this.modalService,
            dialogServiceInstance: this,
            eventBus: this.frameContext.getVirtualRootFrameContext().eventBus,
            componentCallback: this.componentModify,
            modalInstanceCallback: this.modalInstanceCallback.bind(this)
          };
          // ä¼å¨åé¨è¿è¡
          const subject: Subject<any> = innerCompopnent['modalInstance'](modalConfig, parameter);
          return subject;
        } else {
          modalRef = this.modalService.show(innerCompopnent, modalConfig);
        }
      }

      this.modalRef = modalRef;
      this.refs.modalRef = modalRef;
      if (modalRef && !!modalRef.content) {
        modalRef.content.isDialogRootComponent = true;
        modalRef.content.dialogRef = modalRef;
      }
      return modalRef;
    }
  }
  private componentModify(cmpRef: any, parameter: {
    uistate: any
  }) {
    if (cmpRef && cmpRef.instance && cmpRef.instance.viewModel && cmpRef.instance.viewModel.uiState) {
      if (parameter.uistate && typeof parameter.uistate === 'string') {
        parameter.uistate = JSON.parse(parameter.uistate);
      }
      if (typeof parameter.uistate === 'object' && Object.keys(parameter.uistate).length) {
        Object.keys(parameter.uistate).forEach((item) => {
          cmpRef.instance.viewModel.uiState.setPropertyValue(item, parameter.uistate[item]);
        });
      }
      // éå isDialogåæ°
      cmpRef.instance.viewModel.uiState.setPropertyValue('DEVKIT_DIALOG', true);
    }
  }

  private modalInstanceCallback(cmpRef: any, options: any, parameter: any) {
    if (parameter && parameter.modalService) {
      const modalRef = parameter.modalService.show(cmpRef, options);
      this.modalRef = modalRef;
      this.refs.modalRef = modalRef;
      if (modalRef && !!modalRef.content) {
        modalRef.content.isDialogRootComponent = true;
        modalRef.content.dialogRef = modalRef;
      }
      return modalRef;
    }
  }

  /**
   * æå¼ç±»å¸®å©è¡¨å
   * @param frameId
   * @param params
   * @param configs
   * @description å¼¹åºè¡¨ååå¼¹åºè¿ç«¯è¡¨ååºå«ä¸ºå¼¹åºè¡¨åéè¦éç½®å­æ®µæ å°
   */
  public openHelpModal(frameId: string, params: string, configs?: any) {
    const events = this['context']['eventParam'] || {};
    // å¡çåºæ¯ä¼ éè¿æ¥çäºä»¶æ¯èªå®ä¹å¯¹è±¡ï¼åå«eventåoptionsãåè¡¨åºæ¯ä¼ éè¿æ¥çäºä»¶åæ°æ¯æ®éäºä»¶åæ°ï¼å¨åæ°ä¸­æºå¸¦äºeditor.options
    const event = events.event || events;
    const options = events.options || events.editor && events.editor.options || {};
    const context = events && events.context;
    const subject = new Subject<any>();
    // modalIdå¨ä¸¤ç§åºæ¯ä¸é½éè¦ï¼ç¨æ¥åºåå®ä¾
    const { modalId = null } = options;
    if (!configs) {
      configs = '{}';
    }
    if (typeof configs === 'string' && configs.length > 0) {
      configs = JSON.parse(configs);
    }
    const { remote = false, currentRow = false, areaResponse = undefined } = configs || {};
    // æ¯æareaResponseéç½®
    if (areaResponse !== undefined && options.areaResponse === undefined) {
      options.areaResponse = areaResponse;
    }
    if (remote) {
      const mapFields = configs.mapFields || {};
      options.remote = remote + '?v=' + new Date().valueOf();
      this.openModal(options, modalId, params, (dialogRef: any) => {
        // æ°å¢eventåæ°ï¼ä¸ºäºä»¥åè°ç¨eventä¸­çformControlä»¥ééåè¡¨ä¸­çæºè½è¾å¥æ¡å¼¹åºè¡¨åï¼
        this.modals[modalId] = { subject, frameId: frameId, mapFields, dialogRef, currentRow, event: event, context };
      });
    } else {
      const dialogRef = this.openModal(options, modalId, params);
      const mapFields = options.mapFields || {};
      this.modals[modalId] = { subject, frameId: frameId, mapFields, dialogRef, currentRow, event: event, context };
    }
    return subject;
  }

  /**
   * æå¼å¸¦åè°çå¼¹çª
   * @param frameId frameId
   * @param params åæ°
   * @param configs éç½®
   * @returns
   */
  public openCallbackableModal(frameId: string, params?: string, configs?: any) {
    if (!configs) {
      configs = '{}';
    }
    if (typeof configs === 'string') {
      configs = JSON.parse(configs);
    }
    const events = this['context'] && this['context']['eventParam'] || {};
    const options = events.options;
    options.showButtons = true;
    options.buttons = [
      { text: this.languageService.cancel, cls: 'btn', handle: (event: any) => this.cancel(options) },
      {
        text: this.languageService.confirm, cls: 'btn btn-primary', handle: (event: any) => {
          const { modalId = null } = options || {};
          if (modalId) {
            const modal = this.modals[modalId];
            const { subject = null, dialogRef = null, frameId = null, handle = null, currentRow = false } = modal || {};
            const formCmp = dialogRef.content; // å¼¹çªè¡¨åå®ä¾
            if (!formCmp) {
              throw new Error('ä¸æ¯æçè¡¨åç±»å');
            }
            let selectedItems = [];
            if (currentRow === true) {
              let frameComtext: FrameContext;
              if (formCmp.context) {
                frameComtext = formCmp.context.appContext.frameContextManager.getFrameContextById(frameId) as FrameContext;
              } else {
                frameComtext = formCmp.appContext.frameContextManager.getFrameContextById(frameId) as FrameContext;
              }

              if (!frameComtext) {
                throw new Error(`æ æçframeIdï¼${frameId}ï¼è¯·ç¡®è®¤å½ä»¤ä¸­frameIdæ­£ç¡®ã`);
              }
              const bindingList = frameComtext.bindingData.getList() as BindingList;
              const item = bindingList && bindingList.currentItem && bindingList.currentItem.toJSON();
              selectedItems = [item];
            } else {
              let rows: Map<string, any>;
              // å¦æcontextä¸ºç©º é£ä¹å°è¯ä»å¯¹åºçappcontextè¯»åï¼ä¸»è¦ç®çæ¯ä¸ºäºè§£æè¡¨åçå¼¹åº
              if (formCmp.context) {
                rows = formCmp.context.appContext.frameContextManager.getFrameContextById(frameId).uiState.rows || new Map<string, any>();
              } else {
                rows = formCmp.appContext.frameContextManager.getFrameContextById(frameId).uiState.rows || new Map<string, any>();
              }

              selectedItems = Array.from(rows.values());
            }
            if (typeof handle === 'function') {
              handle(selectedItems);
            }
            if (subject) {
              subject.next();
            }
            dialogRef.close(options);
          }
        }
      }
    ];

    const subject = new Subject<any>();
    const { modalId = null } = options;
    const { remote = null, currentRow = false, areaResponse = undefined } = configs;
    const handle = options.handle;
    // æ¯æareaResponseéç½®
    if (areaResponse !== undefined && options.areaResponse === undefined) {
      options.areaResponse = areaResponse;
    }
    if (remote) {
      options.remote = remote + '?v=' + new Date().valueOf();
      this.openModal(options, modalId, params, (dialogRef: any) => {
        this.modals[modalId] = { subject, frameId: frameId, dialogRef, handle, currentRow, event: events.event };
      });
    } else {
      const dialogRef = this.openModal(options, modalId, params);
      this.modals[modalId] = { subject, frameId: frameId, dialogRef, handle, currentRow, event: events.event };
    }
    return subject;
  }

  /**
   * ç¡®è®¤æé®äºä»¶
   * @throws frameId
   */
  public confirm() {
    const events = this['context'] && this['context']['eventParam'] || {};
    const { modalId = null } = events || {};
    if (modalId) {
      const modal = this.modals[modalId];
      const { subject = null, dialogRef = null, mapFields = {}, frameId = null, currentRow = false, event = null, context = null } = modal || {};
      const formCmp = dialogRef.content; // å¼¹çªè¡¨åå®ä¾
      if (!formCmp) {
        throw new Error('ä¸æ¯æçè¡¨åç±»å');
      }
      // const selectedIds = formCmp.context.appContext.frameContextManager.getFrameContextById(frameId).uiState.ids;

      let selectedItems = [];
      if (currentRow === true) {
        const frameComtext = formCmp.context.appContext.frameContextManager.getFrameContextById(frameId) as FrameContext;
        if (!frameComtext) {
          throw new Error(`æ æçframeIdï¼${frameId}ï¼è¯·ç¡®è®¤å½ä»¤ä¸­frameIdæ­£ç¡®ã`);
        }
        const bindingList = frameComtext.bindingData.getList() as BindingList;
        const item = bindingList && bindingList.currentItem && bindingList.currentItem.toJSON();
        if (item && Object.keys(item).length > 0) {
          selectedItems = [item];
        }
      } else {
        const rows: Map<string, any> = formCmp.context.appContext.frameContextManager.getFrameContextById(frameId).uiState.rows || new Map<string, any>();
        selectedItems = Array.from(rows.values());
      }

      // æ å°å­æ®µæ°æ®
      // è·åè§¦åå¼¹æ¡çç¼è¾å¨çå­æ®µåç§°
      let editorField = undefined;
      if (event && event.editor && event.editor.column) {
        editorField = event.editor.column.field;
      }
      if (selectedItems && mapFields) {
        Object.keys(mapFields).forEach((k) => {
          const targetField: string = mapFields[k];
          const sourceKeyArray = k.split('.').filter((p) => p) || [];
          const targetValue = selectedItems.map((r) => {
            return sourceKeyArray.reduce((target, key) => {
              if (target && (target.hasOwnProperty(key) || target['__proto__'].hasOwnProperty(key))) {
                return target[key];
              } else {
                return '';
              }
            }, r);
          }).join(',');
          if (targetField) {
            const bindingPaths = this.frameContext.viewModel.bindingPath.split('/').filter((p) => p);
            const targetFields = targetField.split(',').filter((p) => p);
            targetFields.forEach((target) => {
              if (context) {
                this.setValueByPath(context, target, targetValue);
              } else {
                // ä¿®å¤è¡¨æ ¼æºè½è¾å¥æ¡éæ©å¼åæºè½è¾å¥æ¡å¼ä¸¢å¤±çé®é¢
                if (event.formControl && event.formControl.setValue && event.editor && event.editor.column && event.editor.column.field === target) {
                  event.formControl.setValue(targetValue);
                }
                const targetPath = target.split('.');
                this.frameContext.bindingData.setValue(bindingPaths.concat(targetPath), targetValue, true, true);
              }
            });
          }
        });
      }
      if (subject) {
        subject.next();
      }
      dialogRef.close();
    }
  }
  /**
   * åæ¶æé®äºä»¶
   * @param event
   */
  public cancel(event?: any) {
    const events = event || this['context'] && this['context']['eventParam'] || {};
    const { modalId = null } = events || {};
    if (modalId) {
      const modal = this.modals[modalId];
      const { subject = null, dialogRef = null } = modal || {};
      if (subject) {
        subject.next();
      }
      if (dialogRef) {
        dialogRef.close();
      }
    }
  }
  /**
   * åæ¶æå¡å¨åæ´é
   * @param ref
   */
  private cancelChanges(ref: any): Observable<boolean> {
    if (ref && ref.modalRef && ref.modalRef.content) {
      const component: FrameComponent = ref.modalRef.content as FrameComponent;
      if (component && component.context) {
        const repository = component.context.repository || null;
        if (repository) {
          return repository.cancelChanges().pipe(switchMap(() => of(true)));
        }
      }
    }
    return of(true);
  }
  /**
   * å³é­è¯¥å¼¹çª
   */
  closeModal() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }
  /**
   * åå»ºè¿ç¨è¡¨åå®ä¾
   * @param options dialogéç½®
   * @param uiState uistate
   */
  private createRemoteForm(options: any, uiState: any): Subject<any> {
    const remote = options.remote || false;
    const subject = new Subject<any>();
    if (remote) {
      let moduleName = options.moduleName || null;
      System.import(remote).then((module: any) => {
        if (!moduleName) {
          moduleName = Object.keys(module).pop();
        }
        const moduleFactory = module[moduleName] as NgModuleFactory<any>;
        const moduleRef: NgModuleRef<{ trans?: { resolve?: () => Observable<any> } }> = moduleFactory.create(this.injector);
        const resolve = moduleRef && moduleRef.instance && moduleRef.instance.trans && typeof moduleRef.instance.trans.resolve === 'function' && moduleRef.instance.trans.resolve || (() => of(true));
        resolve.apply(moduleRef.instance.trans).subscribe(() => {
          const entryComponent = moduleRef['_bootstrapComponents'][0];
          if (entryComponent) {
            const compFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(entryComponent);
            const injector = this.createInjector(this.refs);
            const componentRef: ComponentRef<any> = compFactory.create(injector);
            if (componentRef && componentRef.instance && componentRef.instance.viewModel && componentRef.instance.viewModel.uiState) {
              if (typeof uiState === 'object' && Object.keys(uiState).length) {
                Object.keys(uiState).forEach((item) => {
                  componentRef.instance.viewModel.uiState.setPropertyValue(item, uiState[item]);
                });
              }
              // éå isDialogåæ°
              componentRef.instance.viewModel.uiState.setPropertyValue('DEVKIT_DIALOG', true);
            }
            const modalRef = this.modalService.show(componentRef, options);
            subject.next(modalRef);
          } else {
            throw new Error(`æ æ³æ¾å°å¥å£è¡¨åï¼`);
          }
        });
      });
    }
    return subject;
  }
  private setValueByPath(target: object, path: string, value: any) {
    if (target) {
      const paths = path.split('.');
      if (paths.length <= 1) {
        target[path] = value;
      } else {
        paths.slice(0, -1).reduce((prev, path) => {
          if (!(prev.hasOwnProperty(path) || prev['__proto__'].hasOwnProperty(path))) {
            prev[path] = {};
          }
          return prev[path];
        }, target)[paths[paths.length - 1]] = value;
      }
    }
  }
  private createInjector(modalRef: BsModalRef, injector?: Injector) {
    const providers = [
      { provide: INSIDE_DIALOG_TOKEN, useValue: true },
      {
        provide: MODAL_REF, useValue: forwardRef(() => modalRef)
      }
    ];
    return Injector.create({ providers, parent: injector || this.injector });
  }
}

export { DialogService };
